import { Controller } from "@hotwired/stimulus"
import anime from "animejs"
import { useIntersection, useWindowResize } from "stimulus-use"
import { isMobile } from "mobile-device-detect"

export default class extends Controller {
    static targets = ['item', 'clone', 'wrapper']

    connect() {
        useWindowResize(this)
        useIntersection(this)
        
        this.itemTargets.forEach(original => {
            const element = original.cloneNode(true)

            const attr = element.getAttribute(`data-${this.identifier}-target`)
            const targets = attr.replaceAll(/ {2,}/gi, ' ').split(' ')
            targets.push('clone')
            element.setAttribute(`data-${this.identifier}-target`, targets.join(' '))

            this.wrapperTarget.appendChild(element)
        })

        this.recalc()

        this.scrollSpeed = 0
        this.oldScrollY = 0
        this.scrollY = 0
        this.y = 0

        this.touchStart = 0
        this.touchX = 0
        this.isDragging = false

        this.handleSelectStart = () => { return false }

        this.element.addEventListener('selectstart', this.handleSelectStart)

        this.dispose(0)

        const render = () => {
            if (!this.isDragging) {
                this.y = this.y - 2
                this.scrollY = this.scrollY - 2
            }

            this.requestAnimationFrame = requestAnimationFrame(render)
            this.y = this.lerp(this.y, this.scrollY, .1)
            this.dispose(this.y)

            this.scrollSpeed = this.y - this.oldScrollY
            this.oldScrollY = this.y
        }

        this.render = render
    }

    recalc() {
        this.itemWidth = this.itemTarget.clientWidth
        this.wrapWidth = this.itemTargets.length * this.itemWidth

        const px = Math.max.apply(Math, this.itemTargets.map(function(element) {
            return element.clientHeight
        }))

        this.wrapperTarget.style.height = `${px}px`
    }

    nove(event) {
        if (!this.isDragging) return
        this.touchX = event.clientX || event.touches[0].clientX
        this.scrollY += (this.touchX - this.touchStart) * 2.5
        this.touchStart = this.touchX
    }

    end(event) {
        this.isDragging = false
    }

    start(event) {
        this.touchStart = event.clientX || event.touches[0].clientX
        this.isDragging = true
    }

    noDrag(event) {
        event.preventDefault()
    }

    windowResize() {
        this.recalc()
    }

    wrap(min, max, value) {
        const range = max - min
        return (range + (value - min) % range) % range + min
    }

    dispose(scroll) {
        const q = {
            translateX: (target, id, total) => {
                const x = id * this.itemWidth + scroll
                const s = this.wrap(
                    -this.itemWidth,
                    this.wrapWidth - this.itemWidth,
                    parseInt(x)
                )
                return `${s}px`
            },
        }

        if (!isMobile) {
            q.translateZ = 0
        }

        anime.set(this.itemTargets, q)
    }

    lerp(v0, v1, t) {
        return v0 * (1 - t) + v1 * t
    }

    appear() {
        this.render()
    }

    disappear() {
        cancelAnimationFrame(this.requestAnimationFrame)
    }

    disconnect() {
        this.element.removeEventListener('selectstart', this.handleSelectStart)

        cancelAnimationFrame(this.requestAnimationFrame)

        anime.remove(this.itemTargets)
    }
}
